export enum EDeviceTypes {
  phone = 0,
  tablet = 1,
  desktop = 2
}
